import { GET_LEAGUES, GET_SEASONS } from "../actions/teamSeason";
const initialState = {
  leagues: [],
  seasons: [],
};

export default function enrollSeasonReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LEAGUES:
      return {
        ...state,
        leagues: action.data,
      };
    case GET_SEASONS:
      return {
        ...state,
        seasons: action.data,
      };
    default:
      return state;
  }
}
